import { SortParamValues } from 'src/providers/SortProvider'

import { Order_By, ProjectView_Order_By } from 'src/config/generated/graphql'

export function buildListProjectsOrderBy(sort: SortParamValues) {
  let orderBy: ProjectView_Order_By = {
    CreatedOn: Order_By.Desc
  }

  if (!sort.sortColumn) return orderBy

  if (sort.sortColumn === 'Region') {
    orderBy = { Region: { Name: sort.sortOrder as Order_By } }
  } else {
    orderBy = { [sort.sortColumn!]: sort.sortOrder }
  }

  return orderBy
}
